


















































































import Vue from 'vue';
import { truncate } from 'lodash';
import props from './common/props';
import { Name } from '@/models/name';

export default Vue.extend({
  props: {
    ...props.detail
  },
  methods: {
    truncate,
    getSpeakerInitials(name: Name) {
      return (
        name.first.substring(0, 1).toUpperCase() +
        name.last.substring(0, 1).toUpperCase()
      );
    },
    getPersonFullName(name: Name) {
      return name.first + ' ' + name.last;
    }
  }
});
